import React from "react";

import TextareaAutosize from "react-autosize-textarea";

const TextArea = props => {
  const onChange = e => {
    props.onChange({
      name: props.name,
      value: e.target.value
    });
  };

  const { value, placeholder } = props;

  return <TextareaAutosize onChange={onChange} placeholder={placeholder} value={value} />;
};

TextArea.defaultProps = {
  value: "",
  placeholder: ""
};
export default TextArea;
